



























import { defineComponent, computed, watch, ref } from '@vue/composition-api';
import Advert from '@/renderer/components/common/Advert.vue';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import { isAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import storage from '@/renderer/scripts/utils/storage';
import { isChinese, getOrgNameState } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';

import SidebarMenu from './SidebarMenu.vue';
import SidebarUser from './SidebarUser.vue';
export default defineComponent({
  name: 'TheSidebar',
  components: {
    SidebarMenu,
    SidebarUser,
    Advert,
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    let logoClickTimes = 0;
    let logoClickTimer = 0;
    const { inGuide } = sidebarGuideHandler();
    const clearGuideState = (e: MouseEvent) => {
      logoClickTimes++;
      if (logoClickTimes >= 5) {
        logoClickTimes = 0;
        if (e.ctrlKey || e.metaKey) {
          storage.set(storage.StoreKey.REMOTE_PATH, {
            routerName: 'workbench',
          });
          dispatchRouter(
            {
              name: 'transit',
            },
            'replace',
          );
        }
      }
      logoClickTimer && window.clearTimeout(logoClickTimer);
      logoClickTimer = window.setTimeout(() => {
        logoClickTimes = 0;
      }, 500);
    };
    const isShowAdvert = computed(() => {
      const { userRole, editionFlag } = store.getters;
      const flag = editionFlag === 'team' && userRole === 'Admin';
      // 只有个人版和团队版管理员需要展示广告
      return editionFlag === 'personal' || flag;
    });

    // 计算名称的长度,中文字符的宽度是小写英文的两倍,大写英文宽度稍大一些
    const lengthState = computed(() => {
      const name = store.getters.orgName;
      return getOrgNameState(name, 'orgName');
    });
    isShowAdvert.value &&
      reporter.report('pay', {
        pay_source_show: 'negative_banner',
      });
    watch(isShowAdvert, val => {
      if (val) {
        reporter.report('pay', {
          pay_source_show: 'negative_banner',
        });
      }
    });
    return {
      isAdmin,
      inGuide,
      clearGuideState,
      isShowAdvert,
      lengthState,
    };
  },
});
